import Vfocus from "@/directives/Vfocus";
import VIntersection from "@/directives/VIntersection";

export default [
    Vfocus,
    VIntersection
]